import * as React from 'react';

import { ProjectModal, TProjectData } from '../../../components/admin/ProjectModal';
import { selectProjectModal } from 'shared/selectors/admin/projectModal';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'shared/hooks';
import { closeProjectModal } from 'shared/slices/admin/projectModal';
import { createProject, loadProjects, updateProject } from 'shared/thunks/admin';

export const ProjectModalContainer: React.FC = () => {
  const { isOpen, isLoading, id, description, seoPath, title, seoTitle, seoDescription } =
    useSelector(selectProjectModal);

  const dispatch = useAppDispatch();

  const onClose = React.useCallback(() => {
    dispatch(closeProjectModal());
  }, [dispatch]);

  const onConfirm = React.useCallback(
    async (projectData: TProjectData) => {
      const result = await (id
        ? dispatch(updateProject({ ...projectData, id })).unwrap()
        : dispatch(createProject(projectData)).unwrap());

      if (result) {
        dispatch(closeProjectModal());
        dispatch(loadProjects());
      }
    },
    [dispatch, id],
  );
  if (!isOpen) {
    return null;
  }

  return (
    <ProjectModal
      isNew={!id}
      isLoading={isLoading}
      description={description}
      seoPath={seoPath}
      seoTitle={seoTitle}
      seoDescription={seoDescription}
      title={title}
      onClose={onClose}
      onConfirm={onConfirm}
    />
  );
};
